import { ActionInterface } from "../../../Interface/ActionInterface";
import Constants from "../../../Action/Constants";

interface StateInterface {
  dataTypes: object,
};

const initialState: StateInterface = {
  dataTypes: {},
};

export const globalTypesReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST_SUCCESS:
    {
      const  dataTypes = {};

      for (let key in action.payload) {
        let byId = {};

        if(key === "ChargeType") {
          action.payload?.["ChargeType"]?.forEach(function(item, i) {
            item.orderNumber = i;
          });
        }

        action.payload?.[key]?.forEach(type => {
          if (!type) {
            return;
          }

          byId[type.id] = type
          dataTypes[key] = byId
        });
      };
      return {
        ...state,
        ...dataTypes,
      };
    }

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
